import { InputProps, useInput } from '@/hooks/useInput';
import HelperText from './shared/HelperText';
import ErrorText from './shared/ErrorText';
import { ChoiceProps } from '@/hooks/types';
import { Label } from '@/shadcn_components/ui/label';
import { cn } from '@/lib/tailwind-utils';
import MySelect from '../basic/Select';

export type SelectInputProps = InputProps & {
  choices?: ChoiceProps[];
  optionValue?: string;
  optionText?: string;
  emptyOptionText?: string;
  labelSize?: string; // Thêm prop mới cho kích thước label
} & Partial<React.ComponentProps<'div'>>;

const SelectInput = (props: SelectInputProps) => {
  const {
    choices,
    placeholder,
    optionText = 'label',
    optionValue = 'id',
    emptyOptionText,
    className,
    labelSize
  } = props;

  const {
    field: { value, onChange, disabled},
    fieldState,
  } = useInput(props);

  return (
    <div className={cn('w-full', className)}>
      <Label className={cn(labelSize)}>{props.label}</Label>
      <MySelect
        choices={choices}
        value={String(value)}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
        optionText={optionText}
        optionValue={optionValue}
        emptyOptionText={emptyOptionText}
      />
      <HelperText helperText={props.helperText} />
      <ErrorText {...fieldState} />
    </div>
  );
};

export default SelectInput;
